// work order
export const TOGGLE_FAVOURITE_WORK_ORDER = 'USER_TOGGLE_FAVOURITE_WORK_ORDER';
export const TOGGLE_FAVOURITE_STATUS = 'USER_TOGGLE_FAVOURITE_STATUS';
export const ASSIGN_OPERATOR = 'WO_ASSIGN_OPERATOR';
export const UNASSIGN_OPERATOR = 'WO_UNASSIGN_OPERATOR';
export const RELEASE_TO_ALL = 'WO_RELEASE_TO_ALL';
export const REVERT_RELEASE_TO_ALL = 'WO_REVERT_RELEASE_TO_ALL';
export const CLAIM = 'WO_CLAIM';
export const REPORT_TIME_USED = 'WO_REPORT_TIME_USED';
export const PUT_ON_HOLD = 'WO_PUT_ON_HOLD';
export const RELEASE_PUT_ON_HOLD = 'WO_RELEASE_PUT_ON_HOLD';

// work order - lines
export const MARK_WORK_LINE_AS_COMPLETE = 'WO_MARK_WORK_LINE_AS_COMPLETE';
export const UPDATE_INSTALLED_QUANTITY_ON_WORK_LINE = 'WO_UPDATE_INSTALLED_QUANTITY_ON_WORK_LINE';
export const UPDATE_CABLE_LENGTH_ON_WORK_LINE = 'WO_UPDATE_CABLE_LENGTH_ON_WORK_LINE';
export const MARK_WORK_LINE_AS_OPEN = 'WO_MARK_WORK_LINE_AS_OPEN';

// work order - documents
export const WO_UPDATE_DOCUMENT_PROCESS_STATUS = 'WO_UPDATE_DOCUMENT_PROCESS_STATUS';

// work order - feedback
export const WO_CREATE_JOB_FEEDBACK = 'WO_CREATE_JOB_FEEDBACK';

// work order - weight handling (offline line edits; sending is online-only)
export const WO_CREATE_WEIGHT_LINE = 'WO_CREATE_WEIGHT_LINE';
export const WO_UPDATE_WEIGHT_LINE = 'WO_UPDATE_WEIGHT_LINE';
export const WO_DELETE_WEIGHT_LINE = 'WO_DELETE_WEIGHT_LINE';
